module.exports = __webpack_public_path__ + "static/img/kanban01.1a49f441.png";